var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.title))])]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.command))]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }